var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiverpoolGris(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 128,
    viewBox: "0 0 361 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_18)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2682 37.6709V38.2741H92.2434V68.1699H99.4596C100.425 68.1699 101.401 68.0054 102.377 67.6873C103.353 67.3693 104.263 66.8429 105.13 66.0971C105.985 65.3514 106.753 64.3973 107.444 63.2238C108.134 62.0394 108.661 60.6137 109.034 58.9138H109.604V68.795H81.8906V68.1808H85.9155V38.2741H81.8906V37.6709H96.2682Z",
    fill: "url(#paint0_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.503 37.6709V38.2741H123.5V68.1699H127.503V68.784H113.125V68.1699H117.15V38.2741H113.125V37.6709H127.503Z",
    fill: "url(#paint1_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.064 37.6709V38.2741H138.863L147.922 61.9626L157.145 38.2741H153.208V37.6709H161.554V38.2741H157.803L145.476 69.9684H144.204L132.141 38.2741H128.467V37.6709H143.064Z",
    fill: "url(#paint2_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.523 37.6709V45.1503H187.952C187.799 44.6459 187.557 44.0207 187.206 43.2421C186.867 42.4634 186.373 41.7177 185.748 40.9829C185.112 40.2591 184.3 39.634 183.313 39.0856C182.326 38.5483 181.109 38.2741 179.694 38.2741H172.741V51.7853H175.187C176.262 51.7853 177.183 51.6318 177.918 51.3247C178.663 51.0176 179.277 50.579 179.771 50.0087C180.275 49.4494 180.681 48.7584 180.999 47.9579C181.317 47.1682 181.58 46.258 181.789 45.271H182.348V58.859H181.789C181.58 58.0255 181.339 57.203 181.065 56.4133C180.791 55.6237 180.407 54.9328 179.957 54.3406C179.486 53.7484 178.915 53.2768 178.225 52.9149C177.534 52.564 176.689 52.3885 175.669 52.3885H172.741V68.1699H179.903C181.24 68.1699 182.447 67.9505 183.522 67.4899C184.596 67.0403 185.55 66.4152 186.384 65.5817C187.206 64.7701 187.908 63.816 188.457 62.7303C189.005 61.6336 189.433 60.4601 189.718 59.2099H190.288V68.784H162.355V68.1699H166.38V38.2741H162.355V37.6709H188.501H188.523Z",
    fill: "url(#paint3_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.863 38.2741V37.6709H200.454C201.683 37.6709 202.889 37.649 204.084 37.6051C205.28 37.5612 206.475 37.5393 207.704 37.5393C208.833 37.5393 210.039 37.649 211.301 37.8902C212.573 38.1206 213.735 38.5263 214.777 39.0966C215.83 39.6559 216.696 40.4236 217.376 41.3887C218.067 42.3538 218.407 43.5601 218.407 45.0078C218.407 46.1812 218.144 47.1792 217.618 48.0017C217.091 48.8352 216.411 49.5152 215.589 50.0306C214.755 50.557 213.834 50.9628 212.814 51.237C211.794 51.5221 210.785 51.6976 209.798 51.7853V52.0047C211.224 52.2679 212.507 52.5311 213.615 52.7943C214.733 53.0575 215.709 53.4523 216.532 53.9787C217.343 54.4942 218.001 55.2289 218.473 56.1611C218.956 57.0933 219.252 58.3545 219.383 59.9228L219.723 64.3424C219.811 65.4501 219.943 66.3055 220.085 66.9197C220.25 67.5228 220.48 67.9396 220.754 68.148C221.028 68.3454 221.434 68.4441 221.96 68.4441C222.531 68.4441 223.013 68.2796 223.397 67.9396C223.77 67.6106 224.121 67.2925 224.406 66.9964L224.845 67.4022L224 68.2028C223.726 68.455 223.408 68.6634 223.035 68.8498C222.673 69.0253 222.224 69.1569 221.708 69.2666C221.182 69.3653 220.524 69.4201 219.734 69.4201C218.133 69.4201 216.883 69.1679 215.973 68.6524C215.073 68.148 214.404 67.5119 213.966 66.7552C213.527 65.9875 213.253 65.1759 213.154 64.2766C213.066 63.3883 212.99 62.5548 212.957 61.7652C212.902 60.5698 212.814 59.4183 212.715 58.2887C212.617 57.1701 212.375 56.1721 211.992 55.2947C211.619 54.4283 211.048 53.7265 210.292 53.2001C209.535 52.6736 208.471 52.4104 207.1 52.4104H204.216V68.1918H208.241V68.806H193.863V68.1918H197.877V38.2741H193.863ZM206.004 51.7853C207.32 51.7853 208.351 51.6099 209.107 51.2589C209.864 50.9189 210.423 50.4364 210.818 49.8332C211.191 49.241 211.421 48.5611 211.531 47.8043C211.63 47.0476 211.695 46.2799 211.695 45.4903C211.695 44.2072 211.608 43.1105 211.432 42.1893C211.257 41.2681 210.961 40.5113 210.566 39.9191C210.149 39.3269 209.59 38.8773 208.877 38.5921C208.164 38.296 207.254 38.1535 206.146 38.1535C205.828 38.1535 205.499 38.1644 205.181 38.1973L204.216 38.2741V51.7853H206.004Z",
    fill: "url(#paint4_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.737 68.1699V68.784H225.359V68.1699H229.384V38.2741H225.359V37.6709H229.384C230.865 37.6709 232.356 37.649 233.837 37.6051C235.328 37.5612 236.809 37.5393 238.3 37.5393C239.605 37.5393 241.031 37.649 242.545 37.8683C244.058 38.0877 245.462 38.5044 246.745 39.0966C248.028 39.6888 249.092 40.5223 249.958 41.5861C250.825 42.6499 251.241 44.0317 251.241 45.7097C251.241 46.8392 250.967 47.925 250.419 48.923C249.87 49.9319 249.015 50.7983 247.885 51.5441C246.756 52.2898 245.319 52.871 243.597 53.3097C241.876 53.7594 239.858 53.9787 237.533 53.9787H235.734V68.1699H239.759H239.737ZM237.061 53.3536C239.54 53.3536 241.338 52.7943 242.435 51.6757C243.543 50.557 244.102 48.6488 244.102 45.9619C244.102 43.4285 243.619 41.4874 242.654 40.1494C241.689 38.8115 239.945 38.1425 237.412 38.1425C237.094 38.1425 236.776 38.1535 236.491 38.1864L235.701 38.2631V53.3426H237.05L237.061 53.3536Z",
    fill: "url(#paint5_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.54 46.576C256.538 44.5691 257.832 42.8473 259.4 41.4325C260.968 39.9959 262.734 38.8992 264.686 38.1315C266.649 37.3528 268.546 36.969 270.422 36.969C272.429 36.969 274.425 37.3528 276.388 38.1096C278.362 38.8663 280.105 39.941 281.63 41.3448C283.165 42.7486 284.404 44.4375 285.348 46.4334C286.302 48.4294 286.773 50.6776 286.773 53.1891C286.773 55.3824 286.335 57.4552 285.446 59.4183C284.547 61.3923 283.363 63.1141 281.871 64.6056C280.369 66.0861 278.625 67.2706 276.662 68.126C274.688 68.9814 272.615 69.4091 270.433 69.4091C268.25 69.4091 266.199 68.9924 264.214 68.1589C262.24 67.3364 260.497 66.1958 258.994 64.7482C257.492 63.3005 256.285 61.6116 255.397 59.6595C254.487 57.7074 254.037 55.6018 254.037 53.3207C254.037 50.8421 254.542 48.6049 255.551 46.587L255.54 46.576ZM261.67 60.8549C262.021 62.8509 262.569 64.4301 263.304 65.6146C264.05 66.799 265.015 67.6215 266.188 68.0931C267.373 68.5537 268.766 68.795 270.411 68.795C272.571 68.795 274.249 68.3892 275.477 67.5886C276.706 66.788 277.627 65.6694 278.23 64.2656C278.833 62.8509 279.228 61.1839 279.393 59.2428C279.557 57.3016 279.634 55.196 279.634 52.9258C279.634 50.886 279.568 48.9449 279.436 47.0915C279.294 45.249 278.932 43.6149 278.329 42.2002C277.715 40.7855 276.793 39.6669 275.554 38.8443C274.315 38.0109 272.593 37.5941 270.422 37.5941C268.382 37.5941 266.748 37.9889 265.53 38.7566C264.302 39.5353 263.37 40.61 262.734 42.0138C262.098 43.4175 261.67 45.0735 261.462 47.0037C261.253 48.9229 261.166 51.0395 261.166 53.3316C261.166 56.3695 261.341 58.8809 261.681 60.8769L261.67 60.8549Z",
    fill: "url(#paint6_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.939 46.576C292.948 44.5691 294.231 42.8473 295.799 41.4325C297.378 39.9959 299.133 38.8992 301.096 38.1315C303.048 37.3528 304.946 36.969 306.821 36.969C308.828 36.969 310.824 37.3528 312.787 38.1096C314.761 38.8663 316.505 39.941 318.04 41.3448C319.564 42.7486 320.804 44.4375 321.758 46.4334C322.701 48.4294 323.173 50.6776 323.173 53.1891C323.173 55.3824 322.734 57.4552 321.846 59.4183C320.957 61.3923 319.773 63.1141 318.27 64.6056C316.768 66.0861 315.035 67.2706 313.061 68.126C311.098 68.9814 309.025 69.4091 306.832 69.4091C304.638 69.4091 302.599 68.9924 300.625 68.1589C298.64 67.3364 296.896 66.1958 295.393 64.7482C293.891 63.3005 292.685 61.6116 291.796 59.6595C290.886 57.7074 290.447 55.6018 290.447 53.3207C290.447 50.8421 290.941 48.6049 291.95 46.587L291.939 46.576ZM298.08 60.8549C298.42 62.8509 298.98 64.4301 299.725 65.6146C300.46 66.799 301.425 67.6215 302.599 68.0931C303.783 68.5537 305.187 68.795 306.821 68.795C308.981 68.795 310.659 68.3892 311.888 67.5886C313.116 66.788 314.037 65.6694 314.64 64.2656C315.254 62.8509 315.638 61.1839 315.803 59.2428C315.967 57.3016 316.044 55.196 316.044 52.9258C316.044 50.886 315.978 48.9449 315.847 47.0915C315.726 45.249 315.342 43.6149 314.739 42.2002C314.136 40.7855 313.204 39.6669 311.964 38.8443C310.725 38.0109 309.014 37.5941 306.832 37.5941C304.792 37.5941 303.158 37.9889 301.941 38.7566C300.712 39.5353 299.78 40.61 299.144 42.0138C298.508 43.4175 298.08 45.0735 297.883 47.0037C297.674 48.9229 297.576 51.0395 297.576 53.3316C297.576 56.3695 297.751 58.8809 298.102 60.8769L298.08 60.8549Z",
    fill: "url(#paint7_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.389 37.6709V38.2741H337.364V68.1699H344.581C345.546 68.1699 346.511 68.0054 347.498 67.6873C348.474 67.3693 349.395 66.8429 350.251 66.0971C351.106 65.3514 351.874 64.3973 352.565 63.2238C353.245 62.0394 353.782 60.6137 354.155 58.9138H354.725V68.795H327.012V68.1808H331.037V38.2741H327.012V37.6709H341.389Z",
    fill: "url(#paint8_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5229 35.0607V35.0387H51.5119C46.7194 30.0817 40.0186 27 32.594 27C18.0848 27 6.27344 38.8223 6.27344 53.3316C6.27344 59.6704 8.52165 65.4939 12.2723 70.0451C15.7927 74.4209 20.5743 77.5026 26.0358 78.8296C28.1305 79.367 30.3348 79.6521 32.605 79.6521C47.1252 79.6521 58.9365 67.8408 58.9365 53.3316C58.9365 46.236 56.118 39.7874 51.5339 35.0607H51.5229ZM21.0349 46.3895C20.9362 46.9488 20.8594 47.5081 20.7936 48.0784L19.675 47.6507C19.9163 45.0954 21.3091 36.2122 29.2162 29.5443C29.8413 29.4566 30.4664 29.3908 31.1025 29.3469C25.7726 33.6459 22.2303 39.6339 21.0349 46.3895ZM9.72801 45.9508C10.1777 44.58 10.737 43.253 11.4169 42.0027C10.9782 43.6916 10.7808 45.0625 10.6931 45.9728L9.72801 45.9508ZM16.5056 35.5103C17.0978 34.9729 17.7229 34.4685 18.359 33.9969C15.1676 39.2391 14.389 44.229 14.2025 46.3127L12.9962 46.1482C13.1936 44.2838 13.9174 40.0287 16.5056 35.5103ZM23.2941 31.1894C23.7986 30.97 24.303 30.7836 24.8185 30.6081C19.0938 36.947 17.7448 44.0316 17.4268 46.9707L16.4836 46.7404C16.6701 44.6348 17.701 37.4515 23.2941 31.1894ZM49.6366 36.4315C51.8629 40.599 52.4441 44.4374 52.6086 46.0276L52.0274 46.0715C51.8739 44.3058 51.2926 40.248 48.858 35.6748L49.6366 36.4315ZM40.0186 75.5286C41.2688 74.7061 42.4423 73.7848 43.5171 72.754C45.206 71.1528 46.6207 69.2884 47.7284 67.2815C48.836 65.2745 49.6476 63.136 50.2069 60.9536C50.7881 58.7711 51.15 56.5558 51.4461 54.3405C50.9636 56.5229 50.4153 58.6944 49.6695 60.789C48.9128 62.8728 47.9587 64.8797 46.7413 66.6892C45.535 68.4988 44.0544 70.1109 42.3875 71.4599C41.0605 72.5236 39.6128 73.4229 38.0884 74.1796C37.2769 70.6593 38.4504 66.2177 41.5979 60.9316C43.9009 57.0822 45.2279 53.2986 45.6008 49.6247C48.6934 48.6158 52.4332 48.21 55.1968 48.2648C56.5458 54.2199 55.5478 60.3504 52.3674 65.5816C49.505 70.2974 45.184 73.7629 40.0296 75.5286H40.0186ZM49.7353 46.3347L49.1212 46.4224C48.8799 43.9548 47.8161 37.6708 43.1003 31.7267L43.6048 31.9899C48.6496 37.9559 49.5708 44.3058 49.7353 46.3347ZM46.8291 46.883L45.6775 47.1791C45.6446 45.3038 45.3376 43.4394 44.7673 41.6299C43.0565 36.2232 39.8541 32.4506 36.7505 29.6759C37.2769 29.7637 37.7923 29.8843 38.3078 30.0049C45.3595 36.3767 46.6097 44.558 46.8181 46.883H46.8291ZM23.305 46.7953C24.4895 40.0616 28.2182 34.1724 33.8223 30.1804C37.0685 32.8563 40.7863 36.596 42.5849 42.3208C44.2847 47.7494 43.2868 53.6167 39.6238 59.7472C36.8601 64.3862 35.5003 68.5207 35.5441 72.0959L34.8971 70.6483C34.2939 69.1787 33.7455 67.6872 33.2849 66.1738C32.8134 64.6604 32.4295 63.114 32.1005 61.5567C31.7825 59.9994 31.5302 58.4312 31.3438 56.841C30.9709 53.6606 30.8832 50.4582 31.1025 47.2559C31.2122 45.6547 31.3986 44.0535 31.6728 42.4743C31.9689 40.8951 32.3418 39.3158 32.9011 37.8024C32.2431 39.2829 31.7825 40.8293 31.3986 42.3975C31.0258 43.9768 30.7296 45.5779 30.5322 47.1901C30.1155 50.4034 30.0168 53.6715 30.1923 56.9287C30.28 58.5518 30.4555 60.1859 30.6858 61.798C30.9271 63.4101 31.2341 65.0332 31.6289 66.6234C32.0237 68.2136 32.4734 69.8038 33.0327 71.3502L33.3069 72.1069C31.1135 70.4948 29.2491 68.5756 27.6808 66.3054C23.667 60.5368 22.1206 53.6057 23.327 46.7843L23.305 46.7953ZM55.471 45.9618H54.9227C54.8788 45.4354 54.802 44.6677 54.6265 43.7355C54.9336 44.4593 55.2188 45.2051 55.471 45.9618ZM14.0928 68.6414C13.38 67.764 12.722 66.8099 12.1298 65.8119C8.92743 60.46 7.92944 54.2418 9.28934 48.2539C12.371 48.221 16.8346 48.7913 20.6291 50.5131C20.4537 56.5668 22.2193 62.5218 25.7726 67.6324C27.7357 70.4509 30.1923 72.8417 33.0875 74.7719C31.9799 74.4977 30.8832 74.1577 29.8304 73.719C27.2312 72.6772 24.7856 71.1747 22.6361 69.2994C20.4756 67.435 18.6112 65.2197 17.0868 62.7741C16.3191 61.5567 15.6392 60.2736 15.0689 58.9576C14.4877 57.6306 14.027 56.2487 13.72 54.834C13.9393 56.2707 14.3012 57.6854 14.8057 59.0672C15.2882 60.4381 15.8914 61.787 16.5823 63.0702C17.9861 65.6584 19.7518 68.0601 21.8464 70.1438C23.9521 72.2275 26.4087 73.9932 29.1285 75.2983C30.4774 75.9563 31.8921 76.4937 33.3507 76.8885C33.8223 77.031 34.3049 77.1407 34.7874 77.2504C34.0636 77.3052 33.3288 77.3381 32.594 77.3381C25.1694 77.3381 18.5015 73.9493 14.0928 68.6194V68.6414Z",
    fill: "url(#paint9_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2682 37.6709V38.2741H92.2434V68.1699H99.4596C100.425 68.1699 101.401 68.0054 102.377 67.6873C103.353 67.3693 104.263 66.8429 105.13 66.0971C105.985 65.3514 106.753 64.3973 107.444 63.2238C108.134 62.0394 108.661 60.6137 109.034 58.9138H109.604V68.795H81.8906V68.1808H85.9155V38.2741H81.8906V37.6709H96.2682Z",
    fill: "url(#paint10_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.503 37.6709V38.2741H123.5V68.1699H127.503V68.784H113.125V68.1699H117.15V38.2741H113.125V37.6709H127.503Z",
    fill: "url(#paint11_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.064 37.6709V38.2741H138.863L147.922 61.9626L157.145 38.2741H153.208V37.6709H161.554V38.2741H157.803L145.476 69.9684H144.204L132.141 38.2741H128.467V37.6709H143.064Z",
    fill: "url(#paint12_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.523 37.6709V45.1503H187.952C187.799 44.6459 187.557 44.0207 187.206 43.2421C186.867 42.4634 186.373 41.7177 185.748 40.9829C185.112 40.2591 184.3 39.634 183.313 39.0856C182.326 38.5483 181.109 38.2741 179.694 38.2741H172.741V51.7853H175.187C176.262 51.7853 177.183 51.6318 177.918 51.3247C178.663 51.0176 179.277 50.579 179.771 50.0087C180.275 49.4494 180.681 48.7584 180.999 47.9579C181.317 47.1682 181.58 46.258 181.789 45.271H182.348V58.859H181.789C181.58 58.0255 181.339 57.203 181.065 56.4133C180.791 55.6237 180.407 54.9328 179.957 54.3406C179.486 53.7484 178.915 53.2768 178.225 52.9149C177.534 52.564 176.689 52.3885 175.669 52.3885H172.741V68.1699H179.903C181.24 68.1699 182.447 67.9505 183.522 67.4899C184.596 67.0403 185.55 66.4152 186.384 65.5817C187.206 64.7701 187.908 63.816 188.457 62.7303C189.005 61.6336 189.433 60.4601 189.718 59.2099H190.288V68.784H162.355V68.1699H166.38V38.2741H162.355V37.6709H188.501H188.523Z",
    fill: "url(#paint13_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.863 38.2741V37.6709H200.454C201.683 37.6709 202.889 37.649 204.084 37.6051C205.28 37.5612 206.475 37.5393 207.704 37.5393C208.833 37.5393 210.039 37.649 211.301 37.8902C212.573 38.1206 213.735 38.5263 214.777 39.0966C215.83 39.6559 216.696 40.4236 217.376 41.3887C218.067 42.3538 218.407 43.5601 218.407 45.0078C218.407 46.1812 218.144 47.1792 217.618 48.0017C217.091 48.8352 216.411 49.5152 215.589 50.0306C214.755 50.557 213.834 50.9628 212.814 51.237C211.794 51.5221 210.785 51.6976 209.798 51.7853V52.0047C211.224 52.2679 212.507 52.5311 213.615 52.7943C214.733 53.0575 215.709 53.4523 216.532 53.9787C217.343 54.4942 218.001 55.2289 218.473 56.1611C218.956 57.0933 219.252 58.3545 219.383 59.9228L219.723 64.3424C219.811 65.4501 219.943 66.3055 220.085 66.9197C220.25 67.5228 220.48 67.9396 220.754 68.148C221.028 68.3454 221.434 68.4441 221.96 68.4441C222.531 68.4441 223.013 68.2796 223.397 67.9396C223.77 67.6106 224.121 67.2925 224.406 66.9964L224.845 67.4022L224 68.2028C223.726 68.455 223.408 68.6634 223.035 68.8498C222.673 69.0253 222.224 69.1569 221.708 69.2666C221.182 69.3653 220.524 69.4201 219.734 69.4201C218.133 69.4201 216.883 69.1679 215.973 68.6524C215.073 68.148 214.404 67.5119 213.966 66.7552C213.527 65.9875 213.253 65.1759 213.154 64.2766C213.066 63.3883 212.99 62.5548 212.957 61.7652C212.902 60.5698 212.814 59.4183 212.715 58.2887C212.617 57.1701 212.375 56.1721 211.992 55.2947C211.619 54.4283 211.048 53.7265 210.292 53.2001C209.535 52.6736 208.471 52.4104 207.1 52.4104H204.216V68.1918H208.241V68.806H193.863V68.1918H197.877V38.2741H193.863ZM206.004 51.7853C207.32 51.7853 208.351 51.6099 209.107 51.2589C209.864 50.9189 210.423 50.4364 210.818 49.8332C211.191 49.241 211.421 48.5611 211.531 47.8043C211.63 47.0476 211.695 46.2799 211.695 45.4903C211.695 44.2072 211.608 43.1105 211.432 42.1893C211.257 41.2681 210.961 40.5113 210.566 39.9191C210.149 39.3269 209.59 38.8773 208.877 38.5921C208.164 38.296 207.254 38.1535 206.146 38.1535C205.828 38.1535 205.499 38.1644 205.181 38.1973L204.216 38.2741V51.7853H206.004Z",
    fill: "url(#paint14_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.737 68.1699V68.784H225.359V68.1699H229.384V38.2741H225.359V37.6709H229.384C230.865 37.6709 232.356 37.649 233.837 37.6051C235.328 37.5612 236.809 37.5393 238.3 37.5393C239.605 37.5393 241.031 37.649 242.545 37.8683C244.058 38.0877 245.462 38.5044 246.745 39.0966C248.028 39.6888 249.092 40.5223 249.958 41.5861C250.825 42.6499 251.241 44.0317 251.241 45.7097C251.241 46.8392 250.967 47.925 250.419 48.923C249.87 49.9319 249.015 50.7983 247.885 51.5441C246.756 52.2898 245.319 52.871 243.597 53.3097C241.876 53.7594 239.858 53.9787 237.533 53.9787H235.734V68.1699H239.759H239.737ZM237.061 53.3536C239.54 53.3536 241.338 52.7943 242.435 51.6757C243.543 50.557 244.102 48.6488 244.102 45.9619C244.102 43.4285 243.619 41.4874 242.654 40.1494C241.689 38.8115 239.945 38.1425 237.412 38.1425C237.094 38.1425 236.776 38.1535 236.491 38.1864L235.701 38.2631V53.3426H237.05L237.061 53.3536Z",
    fill: "url(#paint15_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.54 46.576C256.538 44.5691 257.832 42.8473 259.4 41.4325C260.968 39.9959 262.734 38.8992 264.686 38.1315C266.649 37.3528 268.546 36.969 270.422 36.969C272.429 36.969 274.425 37.3528 276.388 38.1096C278.362 38.8663 280.105 39.941 281.63 41.3448C283.165 42.7486 284.404 44.4375 285.348 46.4334C286.302 48.4294 286.773 50.6776 286.773 53.1891C286.773 55.3824 286.335 57.4552 285.446 59.4183C284.547 61.3923 283.363 63.1141 281.871 64.6056C280.369 66.0861 278.625 67.2706 276.662 68.126C274.688 68.9814 272.615 69.4091 270.433 69.4091C268.25 69.4091 266.199 68.9924 264.214 68.1589C262.24 67.3364 260.497 66.1958 258.994 64.7482C257.492 63.3005 256.285 61.6116 255.397 59.6595C254.487 57.7074 254.037 55.6018 254.037 53.3207C254.037 50.8421 254.542 48.6049 255.551 46.587L255.54 46.576ZM261.67 60.8549C262.021 62.8509 262.569 64.4301 263.304 65.6146C264.05 66.799 265.015 67.6215 266.188 68.0931C267.373 68.5537 268.766 68.795 270.411 68.795C272.571 68.795 274.249 68.3892 275.477 67.5886C276.706 66.788 277.627 65.6694 278.23 64.2656C278.833 62.8509 279.228 61.1839 279.393 59.2428C279.557 57.3016 279.634 55.196 279.634 52.9258C279.634 50.886 279.568 48.9449 279.436 47.0915C279.294 45.249 278.932 43.6149 278.329 42.2002C277.715 40.7855 276.793 39.6669 275.554 38.8443C274.315 38.0109 272.593 37.5941 270.422 37.5941C268.382 37.5941 266.748 37.9889 265.53 38.7566C264.302 39.5353 263.37 40.61 262.734 42.0138C262.098 43.4175 261.67 45.0735 261.462 47.0037C261.253 48.9229 261.166 51.0395 261.166 53.3316C261.166 56.3695 261.341 58.8809 261.681 60.8769L261.67 60.8549Z",
    fill: "url(#paint16_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.939 46.576C292.948 44.5691 294.231 42.8473 295.799 41.4325C297.378 39.9959 299.133 38.8992 301.096 38.1315C303.048 37.3528 304.946 36.969 306.821 36.969C308.828 36.969 310.824 37.3528 312.787 38.1096C314.761 38.8663 316.505 39.941 318.04 41.3448C319.564 42.7486 320.804 44.4375 321.758 46.4334C322.701 48.4294 323.173 50.6776 323.173 53.1891C323.173 55.3824 322.734 57.4552 321.846 59.4183C320.957 61.3923 319.773 63.1141 318.27 64.6056C316.768 66.0861 315.035 67.2706 313.061 68.126C311.098 68.9814 309.025 69.4091 306.832 69.4091C304.638 69.4091 302.599 68.9924 300.625 68.1589C298.64 67.3364 296.896 66.1958 295.393 64.7482C293.891 63.3005 292.685 61.6116 291.796 59.6595C290.886 57.7074 290.447 55.6018 290.447 53.3207C290.447 50.8421 290.941 48.6049 291.95 46.587L291.939 46.576ZM298.08 60.8549C298.42 62.8509 298.98 64.4301 299.725 65.6146C300.46 66.799 301.425 67.6215 302.599 68.0931C303.783 68.5537 305.187 68.795 306.821 68.795C308.981 68.795 310.659 68.3892 311.888 67.5886C313.116 66.788 314.037 65.6694 314.64 64.2656C315.254 62.8509 315.638 61.1839 315.803 59.2428C315.967 57.3016 316.044 55.196 316.044 52.9258C316.044 50.886 315.978 48.9449 315.847 47.0915C315.726 45.249 315.342 43.6149 314.739 42.2002C314.136 40.7855 313.204 39.6669 311.964 38.8443C310.725 38.0109 309.014 37.5941 306.832 37.5941C304.792 37.5941 303.158 37.9889 301.941 38.7566C300.712 39.5353 299.78 40.61 299.144 42.0138C298.508 43.4175 298.08 45.0735 297.883 47.0037C297.674 48.9229 297.576 51.0395 297.576 53.3316C297.576 56.3695 297.751 58.8809 298.102 60.8769L298.08 60.8549Z",
    fill: "url(#paint17_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.389 37.6709V38.2741H337.364V68.1699H344.581C345.546 68.1699 346.511 68.0054 347.498 67.6873C348.474 67.3693 349.395 66.8429 350.251 66.0971C351.106 65.3514 351.874 64.3973 352.565 63.2238C353.245 62.0394 353.782 60.6137 354.155 58.9138H354.725V68.795H327.012V68.1808H331.037V38.2741H327.012V37.6709H341.389Z",
    fill: "url(#paint18_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5229 35.0607V35.0387H51.5119C46.7194 30.0817 40.0186 27 32.594 27C18.0848 27 6.27344 38.8223 6.27344 53.3316C6.27344 59.6704 8.52165 65.4939 12.2723 70.0451C15.7927 74.4209 20.5743 77.5026 26.0358 78.8296C28.1305 79.367 30.3348 79.6521 32.605 79.6521C47.1252 79.6521 58.9365 67.8408 58.9365 53.3316C58.9365 46.236 56.118 39.7874 51.5339 35.0607H51.5229ZM21.0349 46.3895C20.9362 46.9488 20.8594 47.5081 20.7936 48.0784L19.675 47.6507C19.9163 45.0954 21.3091 36.2122 29.2162 29.5443C29.8413 29.4566 30.4664 29.3908 31.1025 29.3469C25.7726 33.6459 22.2303 39.6339 21.0349 46.3895ZM9.72801 45.9508C10.1777 44.58 10.737 43.253 11.4169 42.0027C10.9782 43.6916 10.7808 45.0625 10.6931 45.9728L9.72801 45.9508ZM16.5056 35.5103C17.0978 34.9729 17.7229 34.4685 18.359 33.9969C15.1676 39.2391 14.389 44.229 14.2025 46.3127L12.9962 46.1482C13.1936 44.2838 13.9174 40.0287 16.5056 35.5103ZM23.2941 31.1894C23.7986 30.97 24.303 30.7836 24.8185 30.6081C19.0938 36.947 17.7448 44.0316 17.4268 46.9707L16.4836 46.7404C16.6701 44.6348 17.701 37.4515 23.2941 31.1894ZM49.6366 36.4315C51.8629 40.599 52.4441 44.4374 52.6086 46.0276L52.0274 46.0715C51.8739 44.3058 51.2926 40.248 48.858 35.6748L49.6366 36.4315ZM40.0186 75.5286C41.2688 74.7061 42.4423 73.7848 43.5171 72.754C45.206 71.1528 46.6207 69.2884 47.7284 67.2815C48.836 65.2745 49.6476 63.136 50.2069 60.9536C50.7881 58.7711 51.15 56.5558 51.4461 54.3405C50.9636 56.5229 50.4153 58.6944 49.6695 60.789C48.9128 62.8728 47.9587 64.8797 46.7413 66.6892C45.535 68.4988 44.0544 70.1109 42.3875 71.4599C41.0605 72.5236 39.6128 73.4229 38.0884 74.1796C37.2769 70.6593 38.4504 66.2177 41.5979 60.9316C43.9009 57.0822 45.2279 53.2986 45.6008 49.6247C48.6934 48.6158 52.4332 48.21 55.1968 48.2648C56.5458 54.2199 55.5478 60.3504 52.3674 65.5816C49.505 70.2974 45.184 73.7629 40.0296 75.5286H40.0186ZM49.7353 46.3347L49.1212 46.4224C48.8799 43.9548 47.8161 37.6708 43.1003 31.7267L43.6048 31.9899C48.6496 37.9559 49.5708 44.3058 49.7353 46.3347ZM46.8291 46.883L45.6775 47.1791C45.6446 45.3038 45.3376 43.4394 44.7673 41.6299C43.0565 36.2232 39.8541 32.4506 36.7505 29.6759C37.2769 29.7637 37.7923 29.8843 38.3078 30.0049C45.3595 36.3767 46.6097 44.558 46.8181 46.883H46.8291ZM23.305 46.7953C24.4895 40.0616 28.2182 34.1724 33.8223 30.1804C37.0685 32.8563 40.7863 36.596 42.5849 42.3208C44.2847 47.7494 43.2868 53.6167 39.6238 59.7472C36.8601 64.3862 35.5003 68.5207 35.5441 72.0959L34.8971 70.6483C34.2939 69.1787 33.7455 67.6872 33.2849 66.1738C32.8134 64.6604 32.4295 63.114 32.1005 61.5567C31.7825 59.9994 31.5302 58.4312 31.3438 56.841C30.9709 53.6606 30.8832 50.4582 31.1025 47.2559C31.2122 45.6547 31.3986 44.0535 31.6728 42.4743C31.9689 40.8951 32.3418 39.3158 32.9011 37.8024C32.2431 39.2829 31.7825 40.8293 31.3986 42.3975C31.0258 43.9768 30.7296 45.5779 30.5322 47.1901C30.1155 50.4034 30.0168 53.6715 30.1923 56.9287C30.28 58.5518 30.4555 60.1859 30.6858 61.798C30.9271 63.4101 31.2341 65.0332 31.6289 66.6234C32.0237 68.2136 32.4734 69.8038 33.0327 71.3502L33.3069 72.1069C31.1135 70.4948 29.2491 68.5756 27.6808 66.3054C23.667 60.5368 22.1206 53.6057 23.327 46.7843L23.305 46.7953ZM55.471 45.9618H54.9227C54.8788 45.4354 54.802 44.6677 54.6265 43.7355C54.9336 44.4593 55.2188 45.2051 55.471 45.9618ZM14.0928 68.6414C13.38 67.764 12.722 66.8099 12.1298 65.8119C8.92743 60.46 7.92944 54.2418 9.28934 48.2539C12.371 48.221 16.8346 48.7913 20.6291 50.5131C20.4537 56.5668 22.2193 62.5218 25.7726 67.6324C27.7357 70.4509 30.1923 72.8417 33.0875 74.7719C31.9799 74.4977 30.8832 74.1577 29.8304 73.719C27.2312 72.6772 24.7856 71.1747 22.6361 69.2994C20.4756 67.435 18.6112 65.2197 17.0868 62.7741C16.3191 61.5567 15.6392 60.2736 15.0689 58.9576C14.4877 57.6306 14.027 56.2487 13.72 54.834C13.9393 56.2707 14.3012 57.6854 14.8057 59.0672C15.2882 60.4381 15.8914 61.787 16.5823 63.0702C17.9861 65.6584 19.7518 68.0601 21.8464 70.1438C23.9521 72.2275 26.4087 73.9932 29.1285 75.2983C30.4774 75.9563 31.8921 76.4937 33.3507 76.8885C33.8223 77.031 34.3049 77.1407 34.7874 77.2504C34.0636 77.3052 33.3288 77.3381 32.594 77.3381C25.1694 77.3381 18.5015 73.9493 14.0928 68.6194V68.6414Z",
    fill: "url(#paint19_linear_243_18)",
    stroke: "#949494",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 348.748,
    height: 53.7379,
    transform: "translate(6 27)",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_243_18",
    x1: 81.0352,
    y1: 67.9396,
    x2: 103.781,
    y2: 45.1942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_243_18",
    x1: 108.947,
    y1: 64.6056,
    x2: 131.692,
    y2: 41.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_243_18",
    x1: 132.514,
    y1: 58.2777,
    x2: 157.343,
    y2: 33.4486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_243_18",
    x1: 161.588,
    y1: 67.9944,
    x2: 190.222,
    y2: 39.3598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_243_18",
    x1: 193.468,
    y1: 68.4002,
    x2: 219.01,
    y2: 42.8583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_243_18",
    x1: 221.181,
    y1: 64.6056,
    x2: 247.107,
    y2: 38.6689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_243_18",
    x1: 258.939,
    y1: 64.6933,
    x2: 281.97,
    y2: 41.6628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_243_18",
    x1: 295.339,
    y1: 64.6933,
    x2: 318.369,
    y2: 41.6519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_243_18",
    x1: 326.167,
    y1: 67.9396,
    x2: 348.913,
    y2: 45.1942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_243_18",
    x1: 13.9722,
    y1: 71.9643,
    x2: 51.2158,
    y2: 34.7207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_243_18",
    x1: 81.0352,
    y1: 67.9396,
    x2: 103.781,
    y2: 45.1942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_243_18",
    x1: 108.947,
    y1: 64.6056,
    x2: 131.692,
    y2: 41.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_243_18",
    x1: 132.514,
    y1: 58.2777,
    x2: 157.343,
    y2: 33.4486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_243_18",
    x1: 161.588,
    y1: 67.9944,
    x2: 190.222,
    y2: 39.3598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_243_18",
    x1: 193.468,
    y1: 68.4002,
    x2: 219.01,
    y2: 42.8583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_243_18",
    x1: 221.181,
    y1: 64.6056,
    x2: 247.107,
    y2: 38.6689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_243_18",
    x1: 258.939,
    y1: 64.6933,
    x2: 281.97,
    y2: 41.6628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_243_18",
    x1: 295.339,
    y1: 64.6933,
    x2: 318.369,
    y2: 41.6519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_243_18",
    x1: 326.167,
    y1: 67.9396,
    x2: 348.913,
    y2: 45.1942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_243_18",
    x1: 13.9722,
    y1: 71.9643,
    x2: 51.2158,
    y2: 34.7207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D0AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3792C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 349,
    height: 53.2114,
    fill: "white",
    transform: "translate(6 27)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiverpoolGris);
export default __webpack_public_path__ + "static/media/LIVERPOOL-GRIS.d74e9fbc54024829ad05286b063161be.svg";
export { ForwardRef as ReactComponent };